import { type PropsWithChildren, useState } from 'react';
import { useFullscreenElement } from '@ardoq/hooks';

type FullscreenManagerProps = PropsWithChildren<{
  isActiveInFullscreen: boolean;
}>;

export const FullscreenManager = ({
  isActiveInFullscreen,
  children,
}: FullscreenManagerProps) => {
  const fullscreenElement = useFullscreenElement();
  const [containerElement, setContainerElement] =
    useState<HTMLDivElement | null>(null);

  const isActive = isActiveInFullscreen
    ? fullscreenElement?.contains(containerElement) === true
    : !fullscreenElement;

  return <div ref={setContainerElement}>{isActive && children}</div>;
};
